<template>
  <div :class="categoryClass()">
    <div class="category-title-block">
      <div class="title">
        Product Category
      </div>
      <span id="close-menu" @click="$emit('closeCategory')">
        Close
      </span>
    </div>
    <ul class="category-list">
      <template v-if="enableNewLanding==='true'">
        <li :class="{'active': isLandingPage }" @click="changeCategory(null)">
          <div>
            <i class="fa-solid fa-house-chimney" />
            Home
          </div>
          <i class="fas fa-chevron-right" />
        </li>
        <li
          v-if="onSaleCategory && onSaleCategory.active"
          :key="onSaleCategory.id"
          :class="{'active':initSelectedCategoryId == onSaleCategory.id}"
          @click="changeCategory(onSaleCategory.id)"
        >
          <div>
            {{ onSaleCategory.name }} <span v-if="onSaleCategory.count">({{ onSaleCategory.count }})</span>
          </div>
          <i class="fas fa-chevron-right" />
        </li>
      </template>
      <li :key="'all'" :class="{'active':initSelectedCategoryId == 'all'}" @click="changeCategory('all')">
        All Products
        <i class="fas fa-chevron-right" />
      </li>
      <li
        v-for="(category) in activeCategories"
        :key="category.id"
        :class="{'active':initSelectedCategoryId == category.id}"
        @click="changeCategory(category.id)"
      >
        <div>
          {{ category.name }} <span v-if="category.count">({{ category.count }})</span>
        </div>
        <i class="fas fa-chevron-right" />
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  props: {
    categories: { type: Array, required: true },
    initSelectedCategoryId: { type: String, required: false, default: undefined },
    hideCategory: { type: Boolean, default: true },
    isLandingPage: { type: Boolean, default: true },
    enableNewLanding: { type: String, required: true },
  },
  computed: {
    activeCategories: function() {
      if (this.categories) {
        return this.categories.filter((category) => category.active && category.id !== 'onSale');
      }
      return [];
    },
    onSaleCategory: function() {
      if (this.categories) {
        return this.categories.find((category) => category.id === 'onSale');
      }
      return null;
    },
  },
  methods: {
    changeCategory: function(id) {
      this.$emit('changeCategory', id);
      this.$emit('closeCategory');
    },
    categoryClass: function () {
      var klass = "categories";
      if (this.hideCategory) {
        klass = `${klass} hideMobile`;
      } else {
        klass = `${klass} showMobile`;
      }
      return klass;
    },
  },
};
</script>
